<template>
  <div class="shipment-create f-c" v-loading="loading">
    <div class="header f-r-vc f-r-hsb">
      <div class="header-left">
        <div class="title bold-oswald" v-if="pageMode === ShipmentCreation">
          Create New Shipment
        </div>
        <div
          class="f-r f-r-vc"
          style="gap: 10px"
          v-if="pageMode === ShipmentUpdate"
        >
          <div class="title">Update Shipment</div>
          <el-link
            type="primary"
            style="padding-top: 2px"
            @click="goToShipmentDetail(shipmentNo)"
            class="title"
          >
            {{ shipmentNo }}
          </el-link>
        </div>
      </div>
      <div class="header-right" style="margin-right: 20px">
        <el-button
          type="primary"
          size="small"
          @click="openConfirmDialog"
          v-if="pageMode === ShipmentCreation"
        >
          Create Shipment
        </el-button>
        <el-button
          type="primary"
          size="small"
          @click="openConfirmDialog"
          v-if="pageMode === ShipmentUpdate"
        >
          Update Shipment
        </el-button>
      </div>
    </div>
    <common-card title="Groups">
      <div class="pallet-group-list f-r">
        <el-button
          :plain="group.id !== selectedGroupId"
          :type="group.id === selectedGroupId ? 'success' : 'primary'"
          v-for="group in groupNames"
          :key="group.id"
          @click="selectedGroupId = group.id"
        >
          <div class="f-r-vc pallet-group">
            <div class="f-c" style="gap: 5px">
              <address-tag class="group-address" :address="group.address" />
              <div class="order-no">{{ group.riiOrderNo }}</div>
            </div>
            <span class="pallet-counts">
              {{ group.palletCount }}
            </span>
            <svg-icon
              icon-class="trash"
              class="trash"
              @click.native.prevent.stop="confirmRemoveGroup(group)"
            />
          </div>
        </el-button>
      </div>
    </common-card>
    <div class="tables f-r">
      <div class="left">
        <el-tabs v-model="selectedTab">
          <el-tab-pane label="Selected Pallets" :name="PalletListTab">
            <pallet-list
              v-if="selectedGroupId"
              :palletQuery="availablePalletQuery"
              :showActions="true"
              :showHeaderOps="false"
              :actionWidth="120"
              :excludeCols="['groupName', 'hold']"
            >
              <template v-slot:actions="props">
                <el-button
                  size="small"
                  type="text"
                  class="danger-text"
                  @click="removePallet(props.row)"
                >
                  Remove
                </el-button>
              </template>
            </pallet-list>
          </el-tab-pane>
          <el-tab-pane label="Not Avaliable" :name="NotAvaliablePaletsTab">
            <pallet-list
              v-if="selectedGroupId"
              :palletQuery="notAvaliablePalletQuery"
              :showActions="false"
              :showHeaderOps="false"
              :actionWidth="120"
              :excludeCols="['groupName', 'hold', 'priority']"
            />
          </el-tab-pane>
          <el-tab-pane label="Goods" :name="GoodsListTab">
            <packing-list
              :queryParams="queryGoods"
              :showActions="false"
              :showHeaderOps="false"
            />
          </el-tab-pane>
        </el-tabs>
      </div>
      <common-card class="right">
        <div class="stats" v-if="selectedGroupId">
          <div class="f-c">
            <div class="f-r order-no" style="gap: 50px">
              <span>
                {{ selectedGroup?.riiOrderNo }}
              </span>
            </div>
            <span v-if="!selectedRiiContainerNo">Local</span>
            <span v-else class="group-address">{{
              selectedRiiContainerNo
            }}</span>
          </div>
          <div class="f-r group-address">
            <address-tag class="address-tag" :address="selectedGroup.address" />
          </div>
          <div style="margin: 10px 2px; gap: 10px" class="f-r-vc">
            Left Oever Pallets with the Same address and in the Same Order
            <svg-icon
              icon-class="info"
              class="svg-danger-color"
              style="font-size: 18px"
            />
          </div>
        </div>
        <div class="address-list f-c">
          <pallet-list
            v-if="selectedGroupId"
            :palletQuery="leftOverPalletQuery"
            :showActions="true"
            :showHeaderOps="false"
            :actionWidth="120"
            :excludeCols="['hold', 'riiContainerNo', 'address']"
          >
            <template v-slot:actions="props">
              <el-button
                size="small"
                type="text"
                class="danger-text"
                @click="addPallet(props.row)"
              >
                Add
              </el-button>
            </template>
          </pallet-list>
        </div>
      </common-card>
    </div>
    <ShipmentConfirmDialog
      ref="confirm"
      :mode="pageMode"
      :palletGroups="palletGroups"
      :shipmentNo="shipmentNo"
    />
  </div>
</template>
<script>
// model
import { ShipmentCreation, ShipmentUpdate } from '@/core/models/shipment'
// components
import CommonCard from '@/components/common/CommonCard.vue'
import PalletList from '@/components/pallet/PalletList.vue'
import PackingList from '@/components/goods/PackingList.vue'
import AddressTag from '@/components/address/AddressTag.vue'
import ShipmentConfirmDialog from '@/components/shipment/ShipmentConfirm.vue'
import { PalletListTab, TabsMixin } from '@/core/mixin/tabs'
import { pageJumps } from '@/core/mixin/pages'
import { UNHOLD } from '@/core/models/constant'
import {
  PalletOffStack,
  PalletOnStack,
  PalletUpcoming
} from '@/core/models/pallet'
import { FalseStatus, TrueStatus } from '@/core/configs/types'
// import { createShipment } from '@/api/shipment'
export default {
  name: 'ShipmentCreate',
  components: {
    CommonCard,
    PalletList,
    PackingList,
    AddressTag,
    ShipmentConfirmDialog
  },
  mixins: [TabsMixin, pageJumps],
  data() {
    return {
      ShipmentUpdate,
      ShipmentCreation,
      palletGroups: [],
      selectedGroupId: null,
      selectedTab: PalletListTab,
      loading: true,
      loadingShipment: false
    }
  },
  mounted() {
    if (this.pageMode === ShipmentCreation) {
      const cartList = JSON.parse(localStorage.getItem('cartList', ''))
      if (!cartList || cartList.length === 0) {
        this.$router.replace({ name: 'StockPage' })
      } else {
        this.$set(this, 'palletGroups', cartList)
        this.selectedGroupId = this.palletGroups[0].id
      }
    }
  },
  computed: {
    shipmentNo() {
      return this.$route.query.no
    },
    shipmentId() {
      return this.$route.query.id
    },
    pageMode() {
      return this.$route.query.mode
    },
    groupNames() {
      const names = this.palletGroups.map((one, index) => {
        return {
          index,
          palletCount: one.palletIds.length,
          ...one
        }
      })
      names.sort((a, b) => a.groupName - b.groupName)
      return names
    },
    selectedGroup() {
      return this.palletGroups?.find(one => one.id === this.selectedGroupId)
    },
    selectedOrderId() {
      return this.selectedGroup?.orderId ?? ''
    },
    selectedRiiContainerNo() {
      return this.selectedGroup?.riiContainerNo ?? ''
    },
    selectedAddressId() {
      return this.selectedGroup?.address?.id ?? ''
    },
    selectedGroupPalletIds() {
      return this.selectedGroup?.palletIds ?? ['xxx']
    },
    availablePalletQuery() {
      if (!this.selectedGroup) return {}
      return {
        ids: this.selectedGroup?.palletIds ?? ['xxx']
      }
    },
    notAvaliablePalletQuery() {
      if (!this.selectedGroup) return {}
      const a = {
        ids: this.selectedGroup?.palletIds ?? ['xxx'],
        inShipment: TrueStatus
      }
      if (this.pageMode === ShipmentUpdate) {
        a.exShipmentIds = [this.shipmentId]
      }
      return a
    },
    palletQuery() {
      if (this.selectedGroup) {
        return {
          ids: this.selectedGroup?.palletIds ?? ['xxx'],
          inShipment:
            this.selectedTab === PalletListTab ? FalseStatus : TrueStatus
        }
      } else {
        return {}
      }
    },
    leftOverPalletQuery() {
      if (this.selectedGroup) {
        return {
          exIds: this.selectedGroup?.palletIds,
          orderIds: [this.selectedOrderId],
          addressId: this.selectedAddressId,
          hold: UNHOLD,
          inShipment: FalseStatus,
          statusList: [PalletOffStack, PalletOnStack, PalletUpcoming]
        }
      } else {
        return {}
      }
    },
    goodsIds() {
      return this.selectedGroup?.goodsIds ?? ['xxx']
    },
    queryGoods() {
      if (this.goodsIds.length === 0) return null
      return { ids: this.goodsIds }
    }
  },
  watch: {
    palletGroups: {
      handler() {
        if (this.pageMode === ShipmentCreation) {
          localStorage.setItem('cartList', JSON.stringify(this.palletGroups))
        } else {
          localStorage.setItem(
            this.shipmentNo,
            JSON.stringify(this.palletGroups)
          )
        }
      },
      deep: true
    },
    pageMode: {
      handler() {
        let cache = null
        switch (this.pageMode) {
          case ShipmentCreation:
            cache = JSON.parse(localStorage.getItem('cartList', ''))
            break
          case ShipmentUpdate:
            cache = JSON.parse(localStorage.getItem(this.shipmentNo, ''))
            break
          default:
            this.goToStock({ mode: ShipmentCreation }, true)
        }
        if (!cache || cache.length === 0) {
          this.goToStock({ mode: ShipmentCreation }, true)
        } else {
          this.$set(this, 'palletGroups', cache)
          this.selectedGroupId = this.palletGroups[0].id
          this.loading = false
        }
      },
      immediate: true
    }
  },
  methods: {
    removePallet(pallet) {
      this.$confirm('Remove pallet?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        const index = this.selectedGroup.palletIds.findIndex(
          one => one === pallet.id
        )
        if (index > -1) {
          const palletIds = [...this.selectedGroup.palletIds]
          palletIds.splice(index, 1)
          this.$set(this.selectedGroup, 'palletIds', palletIds)
          if (this.selectedGroup.palletIds.length === 0) {
            this.removeGroup(this.selectedGroup)
          }
          // save it to local data
          localStorage.setItem('cartList', JSON.stringify(this.palletGroups))
        }
      })
    },
    removeGroup(group) {
      const index = this.palletGroups.findIndex(one => one.id === group.id)
      if (index > -1) {
        if (this.palletGroups.length === 1) {
          this.$confirm(
            'Nothing in shipment, redirect to Stock Page?',
            'Hint',
            {
              confirmButtonText: 'OK',
              cancelButtonText: 'Cancel',
              type: 'warning'
            }
          ).finally(() => {
            this.goToStock({ mode: ShipmentCreation }, true)
          })
        } else {
          if (this.selectedGroupId === group.id) this.selectedGroupId = ''
          this.palletGroups.splice(index, 1)
          this.selectedGroupId = this.palletGroups?.[0]?.id
        }
      }
    },
    confirmRemoveGroup(group) {
      this.$confirm('Remove group, continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.removeGroup(group)
      })
    },
    addPallet(pallet) {
      if (this.selectedGroup.palletIds.includes(pallet.id)) return
      const palletIds = [...this.selectedGroup.palletIds]
      palletIds.push(pallet.id)
      this.$set(this.selectedGroup, 'palletIds', palletIds)
    },
    openConfirmDialog() {
      this.$refs.confirm.open()
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.pageMode === ShipmentUpdate) {
      if (to.fullPath.startsWith(`/shipment/${this.shipmentNo}`)) {
        next()
      } else {
        this.$confirm('Unsaved will be lost, continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        })
          .then(() => {
            localStorage.removeItem(this.shipmentNo)
            next()
          })
          .catch(() => {})
      }
    } else {
      next()
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';

.summary-list {
  gap: 10px;

  .each-summary {
    background-color: rgba($business-color, 0.15);

    .count {
      color: black;
      margin-left: 40px;
      font-size: 18px;
    }
  }
}

.shipment-create {
  .header {
    padding-left: 10px;

    .title {
      font-size: 24px;

      @extend .bold-oswald;
    }

    margin: 0 $home-card-padding-x;
  }

  .pallet-group-list {
    gap: 10px;
    padding-bottom: 10px;
    flex-wrap: wrap;

    .trash {
      font-size: 28px;
      filter: $svg-business-color;

      &:hover {
        color: red !important;
        filter: $svg-danger-color;
      }
    }

    .el-button {
      margin: 0 !important;
      height: unset;

      &.selected-group {
        background-color: $deep-green;
        color: white;
      }
    }

    .pallet-group {
      padding: 3px 0;
      gap: 20px;
    }
  }

  .tables {
    gap: 20px;
    min-height: 700px;

    .left {
      width: 60%;
      border-radius: $home-card-border-radius;
      padding: $home-card-padding-y $home-card-padding-x;
      background-color: white;
      overflow: hidden;

      @extend .shadow-level-three;
    }

    .right {
      width: 40%;
    }

    .common-card {
      margin: 0 !important;
    }

    margin: 0 $home-card-padding-x;
  }

  .group-address {
    font-family: 'oswald bold', sans-serif;
    text-align: left;
    font-size: 20px;
  }

  .order-no {
    font-family: 'oswald light', sans-serif;
    text-align: left;
    font-weight: bolder;
    font-size: 18px;
  }

  .stats {
    .order-no {
      font-size: 36px;
    }

    .group-address {
      font-family: 'oswald bold', sans-serif;
      text-align: left;
      font-size: 20px;

      ::v-deep .address-tag span {
        font-size: 29px !important;
      }

      font-size: 29px;
    }

    @extend .f-c;
  }

  .pallet-counts {
    font-family: 'oswald bold', sans-serif;
    font-size: 36px;
  }

  .address-list {
    .address-count {
      gap: 20px;

      .title {
        font-family: 'oswald bold', sans-serif;
        font-size: 26px;
      }

      .count {
        font-family: 'oswald light', sans-serif;
        font-size: 26px;
      }

      @extend .f-r;
    }
  }
}
</style>
